import { Route, BedDouble, Briefcase, Globe2, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const CARDS = [
  {
    icon: Route,
    title: "Tour Operators",
    body: "Publish multi-day itineraries once, sell them everywhere. Live rates, instant confirmations and direct settlement with zero channel fragmentation.",
    span: "lg:col-span-7",
  },
  {
    icon: BedDouble,
    title: "Hotels & Lodges",
    body: "Fill beds beyond the OTA treadmill. Your inventory, your rate parity, your guest relationship — surfaced to 450+ active trade buyers.",
    span: "lg:col-span-5",
  },
  {
    icon: Briefcase,
    title: "Travel Agencies",
    body: "One login to Southern Africa's full bookable shelf. Build quotes in minutes with net rates, live availability and white-label vouchers.",
    span: "lg:col-span-5",
  },
  {
    icon: Globe2,
    title: "DMCs & Ground Handlers",
    body: "Become the connected backbone of your destination. Distribute contracted supply through the network while keeping operational control.",
    span: "lg:col-span-7",
  },
];

export default function B2BGrid() {
  return (
    <section id="network" className="border-t border-goldline bg-coal/40">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
        <Reveal>
          <p className="kicker mb-6">B2B Network</p>
          <h2 className="max-w-2xl font-serif text-3xl font-semibold leading-snug tracking-tight sm:text-4xl lg:text-5xl">
            Built for every seat <span className="text-gold">at the trade table.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-12">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={0.08 * i} className={`md:col-span-1 ${c.span}`}>
              <div className="group flex h-full flex-col justify-between rounded-2xl border border-line bg-panel/70 p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1 hover:border-gold/40 hover:shadow-[0_24px_60px_-24px_rgba(158,122,34,0.25)] lg:p-10">
                <div>
                  <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-gold/10 text-gold transition-transform duration-500 group-hover:scale-110">
                    <c.icon size={20} />
                  </span>
                  <h3 className="mt-6 font-serif text-2xl font-semibold text-cream">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted">{c.body}</p>
                </div>
                <a
                  href="#waitlist"
                  className="mt-8 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-gold/80 transition-colors duration-300 hover:text-gold"
                >
                  Apply to join <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
